import type { Topic } from "../../../intent/types/common";
import type ISignalsListViewModel from "../../models/view/SignalsListViewModel";
import type SignalTypeListEntry from "../../models/view/SignalTypeListEntry";
import type UISignalsGroupedByType from "../../models/view/UISignalsGroupedByType";
import signalsService from "../signalsService";

import { resolveSignalTypePresentation } from "./renderingStrategy";

type Deps = {
    readonly uiSignalsGroupedByType: Readonly<UISignalsGroupedByType>;
    readonly intentTopics: readonly Topic[];
    readonly intentTopicCreatedAt?: Date;
};

export default function createSignalsListViewModel(deps: Deps): ISignalsListViewModel {
    return {
        get entries(): readonly SignalTypeListEntry[] {
            return signalsService.orderedSignalTypes.map((signalType) => {
                const lifecycleState = signalsService.getSignalTypeLifecycleState(signalType);

                return {
                    signalType,
                    signals: deps.uiSignalsGroupedByType[signalType] ?? [],
                    lifecycleState,
                    presentation: resolveSignalTypePresentation({
                        signalType,
                        lifecycleState,
                        uiSignalsGroupedByType: deps.uiSignalsGroupedByType,
                        intentTopics: deps.intentTopics,
                        intentTopicCreatedAt: deps.intentTopicCreatedAt,
                    }),
                };
            });
        },
        get numberOfSignals(): number {
            return this.entries.reduce((total, entry) => total + entry.signals.length, 0);
        },
    };
}
